import { IBoxComponent } from '@enuan/chat__utils';

export const addFieldDefaultValue = <T extends IBoxComponent>(
	fields: T[],
	data?: Record<string, any>
) => {
	if (!data) return fields;

	return fields.map((field) => {
		if (field.id) {
			const value = data![field.id];
			if (typeof value !== 'undefined') {
				return { ...field, default: value };
			}
		}
		return field;
	});
};
